import React from 'react'
import { Helmet } from 'react-helmet'

const Meta = () => {
  return (
    <>
      <Helmet>
        <title>Campsite Availability & Cancellation Alerts | Wandering Labs</title>
        <meta
          name="description"
          content="Tell us where you want to camp and a date range, and we'll notify you the moment a sold-out campsite opens up from a cancellation — so you can grab a reservation at a fully-booked campground."
        />
        <meta name="robots" content="index, follow" />
        <meta name="googlebot" content="index, follow" />
        <meta name="bingbot" content="index, follow" />
        <link rel="canonical" href="https://wanderinglabs.com" />
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Campsite Availability & Cancellation Alerts | Wandering Labs" />
        <meta
          property="og:description"
          content="Tell us where you want to camp and a date range, and we'll notify you the moment a sold-out campsite opens up from a cancellation."
        />
        <meta property="og:url" content="https://wanderinglabs.com" />
        <meta property="og:site_name" content="Wandering Labs :: Reserve" />
        <meta property="og:image" content="https://wanderinglabs.com/android-chrome-512x512.png" />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:image" content="https://wanderinglabs.com/android-chrome-512x512.png" />
      </Helmet>
    </>
  )
}
export default Meta
